import { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

interface SortOption {
  value: SortField;
  label: string;
}

interface SortDropdownProps {
  value: SortField;
  onChange: (value: SortField) => void;
  icon?: string;
  size?: 'sm' | 'lg';
  className?: string;
}

export type SortField = 'created' | 'updated' | 'verified' | 'rejected';

const SORT_OPTIONS: readonly SortOption[] = [
  { value: 'created', label: 'Unanswered' },
  { value: 'updated', label: 'Answered' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'verified', label: 'Verified' },
];

export const SortDropdown = ({
  value,
  onChange,
  icon = 'fal fa-arrow-down-a-z',
  size = 'sm',
  className = '',
}: SortDropdownProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const handleOptionClick = (optionValue: SortField) => {
    onChange(optionValue);
    setDropdownOpen(false);
  };

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} size={size} className={className}>
      <DropdownToggle className='btn btn-link-secondary p-0 text-decoration-none'>
        <i className={icon} />
      </DropdownToggle>
      <DropdownMenu>
        {SORT_OPTIONS.map((option) => (
          <DropdownItem
            key={option.value}
            onClick={() => handleOptionClick(option.value)}
            active={value === option.value}
          >
            {option.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};
